export default __webpack_public_path__ + "static/media/iias-approved.bb7c15fa.svg";